import { CheckBoldIcon } from './CheckBoldIcon';

/**
 * author: Michael Richins
 * id 2070D6C6-EC09-4507-BE0A-07BFFFAF6DFB
 * name check-bold
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-bold.svg
 * tags
 */
export const SuccessThickIcon = CheckBoldIcon;
export default SuccessThickIcon